// extracted by mini-css-extract-plugin
export var form = "serachByTire-module--form--rd5PQ";
export var formControls = "serachByTire-module--formControls--1ZgzH";
export var itemsDisplay = "serachByTire-module--itemsDisplay--XmDlK";